export enum FilterAssignment {
  NoFilter = -1,
  NotAssigned = 0,
  Assigned = -2,
  AllDepartments = -3,
  Everyone = -4,
}
